// ValidationUtils.js - Form validation helper functions
export const validateEmail = (email) => {
    // Basic email validation regex
    // This checks for a standard format: something@something.something
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) return { valid: true }; // Empty is ok (usually optional field)
    return { 
      valid: emailRegex.test(email),
      message: 'Please enter a valid email address (example@domain.com)'
    };
  };
  
  export const validatePhone = (phone) => {
    if (!phone) return { valid: false, message: 'Phone number is required' };
    
    // Remove spaces, dashes, parentheses, and plus for validation
    const cleanedPhone = phone.replace(/[\s\-\(\)\+]/g, '');
    
    // Basic phone validation: allow digits, minimum length 10
    // This handles most international formats when stripped
    const phoneRegex = /^\d{10,15}$/;
    
    return {
      valid: phoneRegex.test(cleanedPhone),
      message: 'Please enter a valid phone number (minimum 10 digits)'
    };
  };
  
  export const validateRequired = (value, fieldName = 'This field') => {
    return {
      valid: !!value && value.trim() !== '',
      message: `${fieldName} is required`
    };
  };
  
  export const validatePrice = (price) => {
    if (!price) return { valid: false, message: 'Price is required' };
    
    const numPrice = parseFloat(price);
    return {
      valid: !isNaN(numPrice) && numPrice >= 0,
      message: 'Please enter a valid price'
    };
  };
  
  export const validateDiscount = (discount) => {
    if (!discount && discount !== 0) return { valid: true }; // Optional field
    
    const numDiscount = parseFloat(discount);
    return {
      valid: !isNaN(numDiscount) && numDiscount >= 0 && numDiscount <= 100,
      message: 'Discount must be between 0 and 100'
    };
  };
  
  // Helper to format a phone number for display
  export const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    
    // Remove all non-digit characters
    const digits = phone.replace(/\D/g, '');
    
    // Format based on length (this is for South African numbers)
    if (digits.length === 10) {
      return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
    }
    
    // For other formats, just add spaces for readability
    return digits.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
  };
  
  // Format as you type for phone inputs
  export const formatPhoneOnChange = (value) => {
    // Remove all except digits, spaces, +, (), -
    let cleaned = value.replace(/[^\d\s\+\(\)\-]/g, '');
    
    // Prevent excessive formatting characters
    // (This allows reasonable input but prevents weird formatting)
    if ((cleaned.match(/\+/g) || []).length > 1) {
      cleaned = cleaned.replace(/\+/g, '').substring(0, cleaned.length - 1) + '+';
    }
  
    return cleaned;
  };